export const TIMEOUT = 30 * 1000

export const WILDCARD_USER_ID = 1
